"use strict";
const _ = require('lodash');
const tree = {
    '2Entertain': {
        name: '2Entertain',
    },
    Boulebar: {
        name: 'Boulebar',
    },
    'Benne Pastabar': {
        name: 'Benne Pastabar',
    },
    'Familjen Orrmyr': {
        name: 'Familjen Orrmyr',
    },
    Grodan: {
        name: 'Grodan',
    },
    'Gruppo Italiano': {
        name: 'Gruppo Italiano',
    },
    Kulturarenor: {
        name: 'Kulturarenor',
    },
    'Sankt Jörgen Park': {
        name: 'Sankt Jörgen Park',
    },
    Rasta: {
        name: 'Rasta',
    },
    Stureplansgruppen: {
        name: 'Stureplansgruppen',
        children: {
            Griffins: {
                name: 'Griffins',
            },
        },
    },
    Axfood: {
        name: 'Axfood',
        children: {
            Dagab: {
                name: 'Dagab',
            },
            Hemköp: {
                name: 'Hemköp',
                children: {
                    'Handlarägda Hemköp': {
                        name: 'Handlarägda Hemköp',
                    },
                },
            },
            Handlarn: {
                name: 'Handlarn',
            },
            Snabbgross: {
                name: 'Snabbgross',
            },
            Tempo: {
                name: 'Tempo',
            },
            'Mat.se': {
                name: 'Mat.se',
            },
            'Urban Deli': {
                name: 'Urban Deli',
            },
            Willys: {
                name: 'Willys',
                children: {
                    Hemma: {
                        name: 'Hemma',
                    },
                },
            },
        },
    },
    Bergendahls: {
        name: 'Bergendahls',
        children: {
            'City Gross': {
                name: 'City Gross',
            },
            'Den svenska matrebellen': {
                name: 'Den svenska matrebellen',
            },
            Matöppet: {
                name: 'Matöppet',
            },
        },
    },
    'Hawaii Poké': {
        name: 'Hawaii Poké',
    },
    Ica: {
        name: 'Ica',
        children: {
            Maxi: { name: 'Maxi' },
            Kvantum: { name: 'Kvantum' },
            Supermarket: { name: 'Supermarket' },
            Nära: { name: 'Nära' },
        },
    },
    Coop: {
        name: 'Coop',
        children: {
            Stora: { name: 'Stora' },
            Coop: { name: 'Coop' },
            'Coop.se': { name: 'Coop.se' },
            Nära: { name: 'Nära' },
            Konsum: { name: 'Konsum' },
            Extra: { name: 'Extra' },
            Forum: { name: 'Forum' },
        },
    },
    Bishops: {
        name: 'Bishops Arms',
    },
    Pitchers: {
        name: 'Pitchers',
    },
    Plantagen: {
        name: 'Plantagen',
    },
    'Svensk Cater AB': {
        name: 'Svensk Cater AB',
    },
    Systembolaget: {
        name: 'Systembolaget',
    },
    Coor: {
        name: 'Coor',
    },
    'Svenska Brasserier': {
        name: 'Svenska Brasserier',
    },
    'ESS group': {
        name: 'ESS group',
    },
    Götaplatsgruppen: {
        name: 'Götaplatsgruppen',
    },
    Göteborgsfamiljen: {
        name: 'Göteborgsfamiljen',
    },
    'Urban Deli': {
        name: 'Urban Deli',
    },
    'Sen group': {
        name: 'Sen group',
    },
    'Gothia Towers': {
        name: 'Gothia Towers',
    },
    GRAM: {
        name: 'GRAM',
    },
    Goldrest: {
        name: 'Goldrest',
    },
    Nobis: {
        name: 'Nobis',
    },
    'Dirty Taco': {
        name: 'Dirty Taco',
    },
    'Fast Fine': {
        name: 'Fast Fine',
    },
    Kasai: {
        name: 'Kasai',
    },
    'Urban Italian Group': {
        name: 'Urban Italian Group',
    },
};
function getPipeStringValuesHelper(node, existingPath, pipeStringResult) {
    const newValue = existingPath ? `${existingPath}|${node.name}` : node.name;
    pipeStringResult.push(newValue);
    const nodeChildren = node.children || {};
    for (let i = 0; i < Object.keys(nodeChildren).length; i++) {
        const childKey = Object.keys(nodeChildren)[i];
        getPipeStringValuesHelper(node.children[childKey], newValue, pipeStringResult);
    }
}
function getPipeStringValues() {
    const pipeStringResult = [];
    for (let i = 0; i < Object.keys(tree).length; i++) {
        const childKey = Object.keys(tree)[i];
        getPipeStringValuesHelper(tree[childKey], '', pipeStringResult);
    }
    return pipeStringResult
        .map(x => ({ chain: x }))
        .sort((a, b) => {
        if (a.chain < b.chain)
            return -1;
        if (a.chain > b.chain)
            return 1;
        return 0;
    });
}
function getInheritedProperty(pipeString, property) {
    if (!pipeString)
        throw new Error(`property is not found: ${property} |${pipeString}|`);
    const path = pipeString.replace(/\|/g, '.children.');
    const node = _.get(tree, path, {});
    if (_.get(node, property))
        return _.get(node, property);
    return getInheritedProperty(pipeString.split('|').slice(0, -1).join('|'), property);
}
function getInheritedPropertyWithFallback(pipeString, primaryProperty, fallbackProperty) {
    try {
        return getInheritedProperty(pipeString, primaryProperty);
    }
    catch (err) {
        return getInheritedProperty(pipeString, fallbackProperty);
    }
}
function findFirstPathWithPropertyHelper(node, key, value, currentPath = '') {
    const path = currentPath ? `${currentPath}|${node.name}` : node.name;
    if (!node) {
        return null;
    }
    if (_.get(node, key) === value) {
        return path;
    }
    if (!node.children)
        return null;
    for (let i = 0; i < Object.keys(node.children).length; i++) {
        const childKey = Object.keys(node.children)[i];
        const item = node.children[childKey];
        const foundInChild = findFirstPathWithPropertyHelper(item, key, value, path);
        if (foundInChild) {
            return foundInChild;
        }
    }
    return null;
}
function findFirstPathWithProperty(key, value) {
    for (let i = 0; i < Object.keys(tree).length; i++) {
        const childKey = Object.keys(tree)[i];
        const foundInChild = findFirstPathWithPropertyHelper(tree[childKey], key, value);
        if (foundInChild) {
            return foundInChild;
        }
    }
    throw new Error(`did not find key - value: ${key} ${value}`);
}
module.exports = {
    getPipeStringValues,
    getInheritedProperty,
    getInheritedPropertyWithFallback,
    tree,
    findFirstPathWithProperty,
};
